/**
 * Session length when going live — shared by Live Dashboard + LiveStatusControls.
 */

export function sanitizeSessionDurationDraft(raw) {
  return String(raw ?? '').replace(/\D/g, '').slice(0, 3);
}

/**
 * @param {string|number} draft — user input (may be empty while editing)
 * @returns {number} clamped 5–240, default 60 if empty/invalid
 */
export function clampSessionDurationMinutes(draft) {
  const n = parseInt(sanitizeSessionDurationDraft(draft), 10);
  if (!Number.isFinite(n) || n <= 0) return 60;
  return Math.max(5, Math.min(240, n));
}
